import { HEADERS_MARKS, IMAGE_TYPE, LIST_TYPES, PARAGRAPH } from 'constants/editors';

export const isTopLevelTextNode = (type: string = '') => (
  [IMAGE_TYPE, PARAGRAPH, ...LIST_TYPES, ...HEADERS_MARKS].includes(type)
);

export default null;